import { Send } from '@mui/icons-material'
import { TextField } from '@mui/material'
import { UserProfileModel, WSChatMessage } from 'mvppoker-portal-common/api'
import { MVPButton } from 'mvppoker-portal-common/components'
import React, { useEffect, useRef, useState } from 'react'
import { FriendsChatListItem } from './FriendsChatListItem'
import './FriendsChatModal.scss'

export interface FriendsChatModalViewProps
{
	userId: string,
	userAvatar: string,
	chat: WSChatMessage[],
	friend: UserProfileModel,

	clickSendMessage: (message: string) => void
}

export const FriendsChatModalView : React.FC<FriendsChatModalViewProps> = ({ userId, userAvatar, chat, friend, clickSendMessage }) =>
{
	const [inputText, setInputText] = useState('')
	const onClickSend = () : void => {
		clickSendMessage(inputText)
		setInputText('')
	}

	const { avatar, name } = friend.info
	const items = chat.map((message) => <FriendsChatListItem key={message.timestamp} userId={userId} userAvatar={userAvatar} friendProfile={friend} chatMessage={message}  />)

	const messagesEndRef = useRef<null | HTMLDivElement>(null)
	const scrollToBottom = () => {
		messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
	}
	useEffect(() => {
		scrollToBottom()
	}, [items])

	return (
		<>
			<span className='modal-title-l'>{name}</span>
			<img id='friend-avatar' className='avatar' src={avatar} alt='avatar'/>

			<div id='friends-chat-list'>
				{items}
      			<div ref={messagesEndRef} />
			</div>
			<div id="send-message-container">
				<TextField
					id="send-message-field"
					variant="outlined"
					label="Message"
					value={inputText}
					onChange={e => setInputText(e.target.value)}
					onKeyUp={e => e.key === 'Enter' && onClickSend()}
				/>
                <MVPButton id='send-message-button' onClick={onClickSend} >
                    <Send />
                    SEND
                </MVPButton>
			</div>
		</>
	)
}
